var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "install-code" } }, [
    _c("div", { staticClass: "left" }, [
      _c(
        "div",
        { staticClass: "quick-installation" },
        [
          !_vm.settingInitialized
            ? _c("h2", [
                _vm._v(
                  _vm._s(_vm.$t("fastWizard.installationAndInstructions"))
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("h4", { staticClass: "mt-2" }, [
            _vm._v(_vm._s(_vm.$t("fastWizard.installationTrackingCode"))),
          ]),
          _vm._v(" "),
          _c("a-alert", {
            staticClass: "mb-1",
            attrs: {
              message: _vm.$t("fastWizard.installationTrackingCodePlease", {
                bodyTag: "<" + "/" + "head>",
              }),
              type: "warning",
              "show-icon": "",
            },
          }),
          _vm._v(" "),
          _c("prism-editor", {
            staticClass: "my-editor",
            attrs: {
              value: _vm.integrationScript(),
              highlight: _vm.highlighter,
              "line-numbers": false,
              readonly: "",
            },
          }),
          _vm._v(" "),
          _c(
            "a-button",
            {
              staticClass: "mt-2 btnColor",
              staticStyle: { width: "100px" },
              attrs: { type: "primary", danger: "", ghost: "" },
              on: { click: _vm.copyTextToClipboard },
            },
            [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$t("fastWizard.installationInstructionsCopy")) +
                  "\n            "
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "platforms platforms-container" }, [
        _c(
          "div",
          {
            staticClass: "platform platform-content",
            class: { selected: _vm.selectedPlatform === "Instructions" },
            on: {
              click: function ($event) {
                _vm.selectedPlatform =
                  _vm.selectedPlatform === "Instructions"
                    ? null
                    : "Instructions"
              },
            },
          },
          [
            _c("div", { staticClass: "header" }, [
              _c("h4", { staticClass: "mt-2" }, [
                _vm._v(_vm._s(_vm.$t("fastWizard.installationInstructions"))),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "down-arrow" }, [_vm._v("↓")]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.selectedPlatform === "Instructions",
                    expression: "selectedPlatform === 'Instructions'",
                  },
                ],
                staticClass: "content",
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "platform platform-integration",
                    class: { selected: _vm.selectedPlatform === "js" },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        _vm.selectedPlatform2 =
                          _vm.selectedPlatform2 === "js" ? false : "js"
                      },
                    },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "header" },
                      [
                        _c("JSIcon", {
                          staticStyle: { width: "32px", height: "32px" },
                        }),
                        _vm._v(" "),
                        _c(
                          "span",
                          { staticStyle: { "margin-right": "18px" } },
                          [_vm._v("Javascript")]
                        ),
                        _vm._v(" "),
                        _c("span"),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.selectedPlatform2 === "js"
                      ? _c("div", { staticClass: "content" }, [
                          _c("div", [
                            _vm._v(
                              "\n                                " +
                                _vm._s(
                                  _vm.$t(
                                    "fastWizard.installationInstructionsJavascript",
                                    {
                                      bodyTag: "<" + "/" + "body>",
                                    }
                                  )
                                ) +
                                "\n                            "
                            ),
                          ]),
                        ])
                      : _vm._e(),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "platform platform-integration",
                    class: { selected: _vm.selectedPlatform2 === "shopify" },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        _vm.selectedPlatform2 =
                          _vm.selectedPlatform2 === "shopify" ? null : "shopify"
                      },
                    },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "header" },
                      [
                        _c("ShopifyIcon", {
                          staticStyle: { width: "32px", height: "32px" },
                        }),
                        _vm._v(" "),
                        _c(
                          "span",
                          { staticStyle: { "margin-right": "18px" } },
                          [_vm._v("Shopify")]
                        ),
                        _vm._v(" "),
                        _c("span"),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.selectedPlatform2 === "shopify"
                      ? _c("div", { staticClass: "content" }, [
                          _c("div", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "fastWizard.installationInstructionsShopify1"
                                )
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", [
                            _vm._v(
                              "\n                                " +
                                _vm._s(
                                  _vm.$t(
                                    "fastWizard.installationInstructionsShopify2"
                                  )
                                ) +
                                "\n                            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", [
                            _vm._v(
                              "\n                                " +
                                _vm._s(
                                  _vm.$t(
                                    "fastWizard.installationInstructionsShopify3",
                                    {
                                      bodyTag: "<" + "/" + "body>",
                                    }
                                  )
                                ) +
                                "\n                            "
                            ),
                          ]),
                        ])
                      : _vm._e(),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "platform platform-integration",
                    class: { selected: _vm.selectedPlatform === "ideasoft" },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        _vm.selectedPlatform2 =
                          _vm.selectedPlatform2 === "ideasoft"
                            ? null
                            : "ideasoft"
                      },
                    },
                  },
                  [
                    _vm._m(0),
                    _vm._v(" "),
                    _vm.selectedPlatform2 === "ideasoft"
                      ? _c("div", { staticClass: "content" }, [
                          _c("div", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "fastWizard.installationInstructionsIdeaSoft1"
                                )
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "fastWizard.installationInstructionsIdeaSoft2"
                                )
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "fastWizard.installationInstructionsIdeaSoft3"
                                )
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "fastWizard.installationInstructionsIdeaSoft4"
                                )
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "fastWizard.installationInstructionsIdeaSoft5"
                                )
                              )
                            ),
                          ]),
                        ])
                      : _vm._e(),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "platform platform-integration",
                    class: { selected: _vm.selectedPlatform === "wordpress" },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        _vm.selectedPlatform2 =
                          _vm.selectedPlatform2 === "wordpress"
                            ? null
                            : "wordpress"
                      },
                    },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "header" },
                      [
                        _c("WordPressIcon", {
                          staticStyle: { width: "32px", height: "32px" },
                        }),
                        _vm._v(" "),
                        _c("span", [_vm._v("WordPress")]),
                        _vm._v(" "),
                        _c("span"),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.selectedPlatform2 === "wordpress"
                      ? _c("div", { staticClass: "content" }, [
                          _c("div", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "fastWizard.installationInstructionsWordPress1"
                                )
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "fastWizard.installationInstructionsWordPress2"
                                )
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "fastWizard.installationInstructionsWordPress3"
                                )
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", [
                            _vm._v(
                              "\n                                " +
                                _vm._s(
                                  _vm.$t(
                                    "fastWizard.installationInstructionsWordPress4",
                                    {
                                      bodyTag: "<" + "/" + "body>",
                                    }
                                  )
                                ) +
                                "\n                            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "fastWizard.installationInstructionsWordPress5"
                                )
                              )
                            ),
                          ]),
                        ])
                      : _vm._e(),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "platform platform-integration",
                    class: { selected: _vm.selectedPlatform === "opencart" },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        _vm.selectedPlatform2 =
                          _vm.selectedPlatform2 === "opencart"
                            ? null
                            : "opencart"
                      },
                    },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "header" },
                      [
                        _c("OpenCartIcon", {
                          staticStyle: { width: "110px", height: "42px" },
                        }),
                        _vm._v(" "),
                        _c(
                          "span",
                          { staticStyle: { "margin-right": "80px" } },
                          [_vm._v("OpenCart")]
                        ),
                        _vm._v(" "),
                        _c("span"),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.selectedPlatform2 === "opencart"
                      ? _c("div", { staticClass: "content" }, [
                          _c("div", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "fastWizard.installationInstructionsOpenCart1"
                                )
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "fastWizard.installationInstructionsOpenCart2"
                                )
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "fastWizard.installationInstructionsOpenCart3"
                                )
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", [
                            _vm._v(
                              "\n                                " +
                                _vm._s(
                                  _vm.$t(
                                    "fastWizard.installationInstructionsOpenCart4",
                                    {
                                      headTag: "<" + "/" + "head>",
                                    }
                                  )
                                ) +
                                "\n                            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "fastWizard.installationInstructionsOpenCart5"
                                )
                              )
                            ),
                          ]),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("br"),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "platform platform-integration",
                    class: { selected: _vm.selectedPlatform === "ticimax" },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        _vm.selectedPlatform2 =
                          _vm.selectedPlatform2 === "ticimax" ? null : "ticimax"
                      },
                    },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "header" },
                      [
                        _c("TicimaxIcon", {
                          staticStyle: { width: "100px", height: "42px" },
                        }),
                        _vm._v(" "),
                        _c(
                          "span",
                          { staticStyle: { "margin-right": "80px" } },
                          [_vm._v("Ticimax")]
                        ),
                        _vm._v(" "),
                        _c("span"),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.selectedPlatform2 === "ticimax"
                      ? _c("div", { staticClass: "content" }, [
                          _c("div", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "fastWizard.installationInstructionsTicimax1"
                                )
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "fastWizard.installationInstructionsTicimax2"
                                )
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "fastWizard.installationInstructionsTicimax3"
                                )
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", [
                            _vm._v(
                              "\n                                " +
                                _vm._s(
                                  _vm.$t(
                                    "fastWizard.installationInstructionsTicimax4"
                                  )
                                ) +
                                "\n                            "
                            ),
                          ]),
                        ])
                      : _vm._e(),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "platform platform-integration",
                    class: {
                      selected: _vm.selectedPlatform === "eticaretteyim",
                    },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        _vm.selectedPlatform2 =
                          _vm.selectedPlatform2 === "eticaretteyim"
                            ? null
                            : "eticaretteyim"
                      },
                    },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "header" },
                      [
                        _c("EticaretteyimIcon", {
                          staticStyle: { width: "100px", height: "40px" },
                        }),
                        _vm._v(" "),
                        _c(
                          "span",
                          { staticStyle: { "margin-right": "80px" } },
                          [_vm._v("Eticaretteyim")]
                        ),
                        _vm._v(" "),
                        _c("span"),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.selectedPlatform2 === "eticaretteyim"
                      ? _c("div", { staticClass: "content" }, [
                          _c("div", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "fastWizard.installationInstructionsEticaretteyim1"
                                )
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "fastWizard.installationInstructionsEticaretteyim2"
                                )
                              )
                            ),
                          ]),
                        ])
                      : _vm._e(),
                  ]
                ),
              ]
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("br"),
    ]),
    _vm._v(" "),
    _c("div", [
      _c(
        "div",
        { staticClass: "right integration-control" },
        [
          _c("h4", { staticClass: "mt-2" }, [
            _vm._v(_vm._s(_vm.$t("fastWizard.installationVerify"))),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "d-flex align-items-center items-web" },
            [
              _c(
                "md-field",
                { staticStyle: { "margin-top": "22px" } },
                [
                  _c("label", [_vm._v("Website")]),
                  _vm._v(" "),
                  _c("md-input", {
                    model: {
                      value: _vm.website,
                      callback: function ($$v) {
                        _vm.website = $$v
                      },
                      expression: "website",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a-button",
                {
                  staticClass: "ml-1 btnColor",
                  attrs: {
                    type: "primary",
                    disabled: _vm.checking,
                    danger: "",
                    ghost: "",
                  },
                  on: { click: _vm.checkStatus },
                },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(
                        _vm.checking
                          ? _vm.$t("fastWizard.installationVerifyChecking")
                          : _vm.$t("fastWizard.installationVerifyCheck")
                      ) +
                      "\n                "
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.checking
            ? _c(
                "div",
                { staticClass: "text-info p-2 border-info text-loading" },
                [
                  _c("a-icon", { attrs: { type: "loading" } }),
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm.$t("fastWizard.installationVerifyCheckingStatus", {
                          website: _vm.website,
                        })
                      ) +
                      "\n            "
                  ),
                ],
                1
              )
            : _c(
                "div",
                [
                  _vm.isIntegrated
                    ? _c("a-result", {
                        attrs: {
                          title: _vm.$t(
                            "fastWizard.installationCheckingStatusMessageYes",
                            { website: _vm.website }
                          ),
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "icon",
                              fn: function () {
                                return [
                                  _c("a-icon", {
                                    attrs: {
                                      type: "smile",
                                      theme: "twoTone",
                                      twoToneColor: _vm.iconColor,
                                    },
                                  }),
                                ]
                              },
                              proxy: true,
                            },
                            {
                              key: "extra",
                              fn: function () {
                                return undefined
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          4109170606
                        ),
                      })
                    : _c(
                        "div",
                        [
                          !_vm.isShopify()
                            ? _c("a-alert", {
                                attrs: {
                                  message: _vm.$t(
                                    "fastWizard.installationCheckingStatusMessageNo",
                                    { website: _vm.website }
                                  ),
                                  banner: "",
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                ],
                1
              ),
          _vm._v(" "),
          _vm.isShopify()
            ? _c("a-alert", {
                attrs: {
                  type: "success",
                  "show-icon": "",
                  message: "Configuration Completed",
                  description:
                    "Yeah , you are SHOPIFY merchant 🎉🎉🎉.  Zero Configuration for Shopify users, supsis is auto integrated your website.",
                  banner: "",
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "header" }, [
      _c("img", {
        staticStyle: { width: "102px", height: "32px" },
        attrs: { src: "/static/img/ideasoft.png", alt: "loader" },
      }),
      _vm._v(" "),
      _c("span", { staticStyle: { "margin-right": "75px" } }, [
        _vm._v("IdeaSOFT"),
      ]),
      _vm._v(" "),
      _c("span"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }